import React, { Component } from "react";
import "datatables.net-bs4/css/dataTables.bootstrap4.min.css";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.min.css";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons-dt/css/buttons.dataTables.css";
import {
  main_url,
  getMainRole,
  getUserId,
  getInformation,
  print,
  fno,
  getFirstDayOfPrevMonth,
  getFirstDayOfMonth,
  getBranch,
  getDepartment,
  getRegion,
  getDesignationList,
  getAllEmployeeCode,
} from "../../../utils/CommonFunction";
import { EAM_Benefit_Status } from "./../../../utils/StatusData.js";
import Select from "react-select";
import "jspdf-autotable";
import DatePicker from "react-datetime";
import moment from "moment";
import { imgData } from "../../../utils/Global";
import * as jsPDF from "jspdf";
import { getHeaders } from "../../../utils/apiHelper.js";
import DateTimeService from "../../../utils/dateTimeService.js";
const $ = require("jquery");
const jzip = require("jzip");
window.JSZip = jzip;
$.DataTable = require("datatables.net-bs4");
$.DataTable = require("datatables.net-responsive-bs4");

$.DataTable = require("datatables.net");
require("datatables.net-buttons/js/dataTables.buttons.min");
require("datatables.net-buttons/js/buttons.html5.min");

class CycleTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: getUserId("user_info"),
      requestData: [],
      start_date: new Date(getFirstDayOfPrevMonth()),
      end_date: new Date(),
      tab: this.props.tab,
      pending_approve: "allrequest",
      dataList: [],
      data: [],
      eam_status_list: EAM_Benefit_Status, //Added by STHA
      selected_status: {
        label: "All",
        value: -1,
      }, //Added by STHA
      loading: false,
      //Added for NEW CRN
      employeeIdList: [],
      branch: [], //Added by STHA
      positionList: [],
      regionList: [],
      departmentList: [],
      selected_employeeId: {
        label: "All",
        value: 0,
      },
      selected_branch: {
        label: "All",
        value: 0,
      },
      selected_position: {
        label: "All",
        value: 0,
      },
      selected_region: {
        label: "All",
        value: 0,
      },
      selected_department: {
        label: "All",
        value: 0,
      },
    };
  }

  componentDidMount() {
    // this.getAllBenefits();
    this.getAllFilterLists();
    this.handleSearchData();
  }

  setTableBtnActions() {
    let that = this;
    $("#dataTables-table").on("click", "#toView", function () {
      var data = $(this).find("#view").text();
      data = $.parseJSON(data);
      that.props.goToViewForm(data);
    });
    $("#dataTables-table").on("click", "#toPrint", function () {
      var data = $(this).find("#print").text();
      data = $.parseJSON(data);
      that.getPrintData(data);
      // fetch(`${main_url}benefit/getMedicalAvailableAmount/${data.user_id}/${moment().format('YYYY')}`)
      //     .then(res => { if (res.ok) return res.json() })
      //     .then(list => {

      //     })
    });

    $("#dataTables-table").on("click", "#toEdit", function () {
      var data = $(this).find("#edit").text();
      data = $.parseJSON(data);
      that.props.goToEditForm(data);
    });
  }

  //Added by STHA
  getAllFilterLists = async () => {
    let employeCode = await getAllEmployeeCode();
    employeCode = employeCode.map((v) => ({
      ...v,
      label: v.employee_code,
      value: v.user_id,
    }));
    employeCode.unshift({ label: "All", value: 0 });

    let branches = await getBranch();
    branches.unshift({ label: "All", value: 0 });

    let department = await getDepartment();
    department.unshift({ label: "All", value: 0 });

    let region = await getRegion();
    region = region.map((v) => ({
      ...v,
      label: v.state_name,
      value: v.state_id,
    }));
    region.unshift({ label: "ALL", value: 0 });

    let designations = await getDesignationList();
    designations.unshift({ label: "ALL", value: 0 });

    this.setState({
      eam_status_list: EAM_Benefit_Status,
      employeeIdList: employeCode,
      branch: branches,
      positionList: designations,
      regionList: region,
      departmentList: department,
    });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.tab != this.props.tab) {
      this.setState(
        {
          tab: this.props.tab,
        },
        () => this.filter()
      );
    }
    if (prevProps.permission !== this.props.permission) {
      this.setState(() => {
        this._setTableData(this.state.data);
      });
    }
  }

  //Added by STHA
  handleSearchStatus = (event) => {
    this.setState({
      selected_status: event,
    });
  };

  handleSelectedEmpId = async (event) => {
    this.setState({
      selected_employeeId: event,
    });
  };

  handleSelectedBranch = async (event) => {
    this.setState({
      selected_branch: event,
    });
  };

  handleSelectedPositon = async (event) => {
    this.setState({
      selected_position: event,
    });
  };

  handleSelectedRegion = async (event) => {
    this.setState({
      selected_region: event,
    });
  };

  handleSelectedDepartment = async (event) => {
    this.setState({
      selected_department: event,
    });
  };

  getRequest() {
    this.search(0);
  }
  getCheck() {
    this.search(1);
  }

  getVerified() {
    this.search(2);
  }
  getApprove() {
    this.search(3);
  }
  getReject() {
    this.search(4);
  }
  getPendingForPayment() {
    this.search(22);
  }
  getAllBenefits() {
    let id = this.state.user_id;
    // fetch(main_url + "cycleInsurance/getCycleInsurance/" + id)
    fetch(
      main_url +
        "cycleInsurance/getCycleInsurance/" +
        id +
        "/" +
        moment(this.props.start_date).format("YYYY-MM-DD") +
        "/" +
        moment(this.props.end_date).format("YYYY-MM-DD"), {
          headers: getHeaders(),
        }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res) {
          this.setState(
            {
              data: res,
              requestData: res.filter((v) => v.createdBy != this.state.user_id),
            },
            () => this._setTableData(this.state.requestData)
          );
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }
  getMyBenefits() {
    let id = this.state.user_id;
    // fetch(main_url + "cycleInsurance/getCycleInsurance/" + id)
    fetch(
      main_url +
        "cycleInsurance/getCycleInsurance/" +
        id +
        "/" +
        moment(this.props.start_date).format("YYYY-MM-DD") +
        "/" +
        moment(this.props.end_date).format("YYYY-MM-DD"), {
          headers: getHeaders(),
        }
    )
      .then((response) => {
        if (response.ok) return response.json();
      })
      .then((res) => {
        if (res) {
          this.setState(
            {
              requestData: res,
              requestData: res.filter((v) => v.createdBy == this.state.user_id),
            },
            () => this._setTableData(this.state.requestData)
          );
        }
      })
      .catch((error) => console.error(`Fetch Error =\n`, error));
  }
  handleStartDate = async (event) => {
    this.setState({
      start_date: event,
    });
  };
  handleEndDate = async (event) => {
    this.setState({
      end_date: event,
    });
  };
  search(status) {
    let data = this.state.dataList;
    data = data.filter((d) => {
      return status === d.status;
    });
    this._setTableData(data);
  }
  approvedlist = async (data) => {
    if (data == "myrequest") {
      this.setState(
        {
          data: this.state.dataList.filter(
            (v) => v.user_id == this.state.user_id
          ),
          pending_approve: "myrequest",
        },
        () => {
          this._setTableData(this.state.data);
        }
      );
    } else {
      this.setState(
        {
          data: this.state.dataList.filter(
            (v) => v.user_id != this.state.user_id
          ),
          pending_approve: "allrequest",
        },
        () => {
          this._setTableData(this.state.data);
        }
      );
    }
  };
  handleSearchData = async () => {
    this.setState({
      loading: true,
    });
    let id = this.state.user_id;

    let status = this.state.selected_status.value;
    let empID = this.state.selected_employeeId.value;
    let branchID = this.state.selected_branch.value;

    let position = this.state.selected_position.value;
    let region = this.state.selected_region.value;
    let department = this.state.selected_department.value;

    // console.log("Here is data ", status, empID, branchID);
    console.log("status", status);
    console.log("employee data", empID);
    console.log("branchID", branchID);
    console.log("position", position);
    console.log("region", region);
    console.log("department", department);

    let getCycleInsuranceBenefit = `
    ${main_url}cycleInsurance/getCycleInsurance/${id}/${moment(
      this.state.start_date
    ).format("YYYY-MM-DD")}/${moment(this.state.end_date).format(
      "YYYY-MM-DD"
    )}/${status}/${empID}/${branchID}/${position}/${region}/${department}
    `;

    // fetch(main_url + "external_benefit/getExternalBenefit/" + id)

    fetch(
      // main_url +
      //   "cycleInsurance/getCycleInsurance/" +
      //   id +
      //   "/" +
      //   moment(this.state.start_date).format("YYYY-MM-DD") +
      //   "/" +
      //   moment(this.state.end_date).format("YYYY-MM-DD")
      getCycleInsuranceBenefit, {
        headers: getHeaders(),
      }
    )
      .then((res) => {
        if (res.ok) return res.json();
      })
      .then((list) => {
        if (this.state.pending_approve == "myrequest") {
          this.setState(
            {
              dataList: list,
              data: list.filter((v) => v.user_id == this.state.user_id),
              loading: false,
            },
            () => {
              this._setTableData(this.state.data);
            }
          );
        } else if (this.state.pending_approve == "allrequest") {
          this.setState(
            {
              dataList: list,
              data: list.filter((v) => v.user_id != this.state.user_id),
              loading: false,
            },
            () => {
              this._setTableData(this.state.data);
            }
          );
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  };

  async getPrintData(data) {
    var info = await getInformation(
      "cycleInsurance",
      data.cycle_insurance_benefit_id
    );
    var doc = new jsPDF("p", "mm", "a4");
    var col = ["Start Date", "Expire Date", "Amount"];
    var rows = [];
    var today = moment(Date.now()).format("YYYY-MM-DD");
    var temp = [
      moment(data.start_date).format("YYYY-MM-DD"),
      moment(data.expire_date).format("YYYY-MM-DD"),
      data.approve_amount,
    ];
    rows.push(temp);
    doc.setFontSize(12);
    doc.addImage(imgData, "image/jpeg", 10, 10, 50, 15);
    doc.text("HR-00031", 140, 15);
    doc.text("Motorcycle Insurance Support Form", 140, 25);
    doc.text("Generate Date: " + today, 13, 40);
    doc.text("Voucher No: " + fno.fno_cycle + data.form_no, 140, 40);
    doc.autoTable(col, rows, { startY: 55 });
    if (doc.previousAutoTable.finalY > 220) {
      doc.addPage();
      doc.previousAutoTable.finalY = 0;
    }
    doc.setFontSize(10);
    doc.setFontType("bold");
    doc.text("Request By", 13, doc.previousAutoTable.finalY + 17);
    doc.text("Check By", 65, doc.previousAutoTable.finalY + 17);
    doc.text("Verify By", 114, doc.previousAutoTable.finalY + 17);
    doc.text("Approve By", 164, doc.previousAutoTable.finalY + 17);
    doc.setFontSize(9);
    doc.setFontType("normal");
    doc.text(
      moment.parseZone(info.requested.requested_date).format("YYYY-MM-DD"),
      13,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(
      info.requested.employment_id,
      13,
      doc.previousAutoTable.finalY + 30
    );
    doc.text(
      info.requested.requested_by,
      13,
      doc.previousAutoTable.finalY + 35
    );
    doc.text(info.requested.branch_name, 13, doc.previousAutoTable.finalY + 40);
    doc.text(
      info.requested.designations,
      13,
      doc.previousAutoTable.finalY + 45
    );
    doc.text(
      moment.parseZone(info.checked.checked_date).format("YYYY-MM-DD"),
      65,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(info.checked.employment_id, 65, doc.previousAutoTable.finalY + 30);
    doc.text(info.checked.checked_by, 65, doc.previousAutoTable.finalY + 35);
    doc.text(info.checked.branch_name, 65, doc.previousAutoTable.finalY + 40);
    doc.text(info.checked.designations, 65, doc.previousAutoTable.finalY + 45);
    doc.text(
      moment.parseZone(info.verified.verified_date).format("YYYY-MM-DD"),
      114,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(
      info.verified.employment_id,
      114,
      doc.previousAutoTable.finalY + 30
    );
    doc.text(info.verified.verified_by, 114, doc.previousAutoTable.finalY + 35);
    doc.text(info.verified.branch_name, 114, doc.previousAutoTable.finalY + 40);
    doc.text(
      info.verified.designations,
      114,
      doc.previousAutoTable.finalY + 45
    );
    doc.text(
      moment.parseZone(info.approved.approved_date).format("YYYY-MM-DD"),
      164,
      doc.previousAutoTable.finalY + 25
    );
    doc.text(
      info.approved.employment_id,
      164,
      doc.previousAutoTable.finalY + 30
    );
    doc.text(info.approved.approved_by, 164, doc.previousAutoTable.finalY + 35);
    doc.text(info.approved.branch_name, 164, doc.previousAutoTable.finalY + 40);
    doc.text(
      info.approved.designations,
      164,
      doc.previousAutoTable.finalY + 45
    );
    // doc.save('Medical Benefit.pdf');
    print(doc, data);
  }
  _setTableData = (data) => {
    var table;
    var l = [];
    var status;
    var permission = this.props.permission;
    var has_action =
      permission.isView === 1 || permission.isEdit === 1 ? true : false;
    for (var i = 0; i < data.length; i++) {
      let result = data[i];
      let obj = [];
      if (result.status === 0) {
        status =
          '<small class="label label-warning" style="background-color:#509aed"> Request </small>';
      } else if (result.status === 1) {
        status =
          '<small class="label label-warning" style="background-color:#b33ce0"> Check </small>';
      } else if (result.status === 2) {
        status =
          '<small class="label label-warning" style="background-color:#f2a509"> Verify </small>';
      } else if (result.status === 3) {
        status =
          '<small class="label label-warning" style="background-color:#29a50a"> Approve </small>';
      } else if (result.status === 4) {
        status =
          '<small class="label label-warning" style="background-color:#f60e2f"> Reject</small>';
      } else if (result.status === 5) {
        status =
          '<small class="label label-warning" style="background-color:#cc0066"> ReferBack </small>';
      }
      //Added by STHA
      else if (result.status === 22) {
        status =
          '<small class="label label-warning" style="background-color:#db26de"> Pending For Payment </small>';
      } else if (result.status === 27) {
        status =
          '<small class="label label-warning" style="background-color:#ed5565"> Payment Reject </small>';
      } else if (result.status === 18) {
        status =
          '<small class="label label-warning" style="background-color:#c9a812"> Payment Approve </small>';
      } else if (result.status === 19) {
        status =
          '<small class="label label-warning" style="background-color:#4ab510"> Payment Receive </small>';
      } else if (result.status === 25) {
        status =
          '<small class="label label-warning" style="background-color:#008A5F"> Payment Finish </small>';
      } else if (result.status === 28) {
        status =
          '<small class="label label-warning" style="background-color:#cc0066"> Payment Refer Back </small>';
      } else if (result.status === 31) {
        status =
          '<small class="label label-warning" style="background-color:#cc0080"> Payment Receive Refer Back </small>';
      }
      obj = {
        no: i + 1,
        form_no: fno.fno_cycle + data[i].form_no,
        req_date: new DateTimeService(data[i].requested_date).formatDate,
        employee_name: data[i].fullname,
        employee_id: data[i].employment_id,
        start_date: new DateTimeService(data[i].start_date).formatDate,
        expire_date: new DateTimeService(data[i].expire_date).formatDate,
        insurance_amount: data[i].insurance_amount,
        approve_amount: data[i].approve_amount,
        status: status ? status : "",
        designations: data[i].designations,
        deptname: data[i].deptname,
        branch_name: data[i].branch_name,
        state_name: data[i].state_name,
      };

      if (has_action) {
        // if (result.status !== 3) {
        if (
          result.status === 0 ||
          result.status === 1 ||
          result.status === 2 ||
          result.status === 4 ||
          result.status === 5 ||
          result.status === 28
        ) {
          obj.action =
            permission.isView === 1
              ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
                JSON.stringify(result) +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
              : "";
          obj.action +=
            permission.isEdit === 1 ||
            (result.status == 5 && data[i].createdBy == this.state.user_id)
              ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toEdit" ><span id="edit" class="hidden" >' +
                JSON.stringify(result) +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;Edit</button>'
              : "";
        } else {
          obj.action =
            permission.isView === 1
              ? '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toView" ><span id="view" class="hidden" >' +
                JSON.stringify(result) +
                '</span>  <i className="fa fa-cogs"></i>&nbsp;View</button>'
              : "";

          if (result.print === 1) {
            obj.action +=
              '<button style="margin-right:10px" class="btn btn-info btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
              JSON.stringify(result) +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;Printed</button>';
          } else {
            obj.action +=
              '<button style="margin-right:10px" class="btn btn-primary btn-sm own-btn-edit" id="toPrint" ><span id="print" class="hidden" >' +
              JSON.stringify(result) +
              '</span>  <i className="fa fa-cogs"></i>&nbsp;Print</button>';
          }
        }
      }

      l.push(obj);
    }
    if ($.fn.dataTable.isDataTable("#dataTables-table")) {
      table = $("#dataTables-table").dataTable();
      table.fnClearTable();
      table.fnDestroy();
      $("#dataTables-table").empty();
    }
    var column = [
      { title: "No", data: "no" },
      { title: "Form No", data: "form_no" },
      { title: "Request Date", data: "req_date" },
      { title: "Employee Name", data: "employee_name" },
      { title: "Employee Id", data: "employee_id" },
      { title: "Position", data: "designations" },
      { title: "Department", data: "deptname" },
      { title: "Branch Name", data: "branch_name" },
      { title: "Region", data: "state_name" },
      { title: "Start Date", data: "start_date" },
      { title: "Expire Date", data: "expire_date" },
      { title: "Insurance Amount", data: "insurance_amount" },
      { title: "Approve Amount", data: "approve_amount" },
      { title: "Status", data: "status" },
    ];

    if (has_action) {
      column.push({ title: "Action", data: "action" });
    }

    table = $("#dataTables-table").DataTable({
      autofill: true,
      bLengthChange: false,
      bInfo: false,
      responsive: true,
      paging: true,
      pageLength: 50,
      // buttons: true,
      dom: "Bfrtip",
      // buttons: [
      //     'copy', 'csv', 'excel', 'pdf'
      // ],
      buttons: [
        "copy",
        {
          extend: "csvHtml5",
          title: "Cycle Insurance",
        },
        {
          extend: "excelHtml5",
          title: "Cycle Insurance",
        },
        {
          extend: "pdfHtml5",
          title: "Cycle Insurance",
        },
      ],
      data: l,
      columns: column,
    });

    this.setTableBtnActions();
  };

  render() {
    return (
      <div>
        {this.state.loading && (
          <div
            className="loadingContainer col-lg-12 "
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <h1 className="fadingLoading">Loading...</h1>
          </div>
        )}
        {!this.state.loading && (
          <div>
            <div>
              <ul className="nav nav-tabs tab" role="tablist" id="tab-pane">
                <li className="nav-item">
                  <a
                    className="nav-link "
                    href="#wedding_benefit"
                    role="tab"
                    data-toggle="tab"
                    aria-selected="true"
                    onClick={() => this.approvedlist("myrequest")}
                  >
                    My Request
                  </a>
                </li>
                <li className="nav-item1 active">
                  <a
                    className="nav-link active"
                    href="#wedding_benefit"
                    role="tab"
                    data-toggle="tab"
                    onClick={() => this.approvedlist("allrequest")}
                  >
                    All Request
                  </a>
                </li>
              </ul>
            </div>
            <div
              className=""
              style={{
                marginTop: 20,
                alignItems: "end",
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {/* <div className="col-md-2">
                <label htmlFor="">Start Date</label>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.start_date}
                  onChange={this.handleStartDate}
                  timeFormat={false}
                />
              </div>
              <div className="col-md-2">
                <label htmlFor="">End Date</label>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.end_date}
                  onChange={this.handleEndDate}
                  timeFormat={false}
                />
              </div> */}

              {/* Added by STHA  */}
              <div
                className="col-lg-3 col-md-6 col-sm-12 "
                style={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label className="col-sm-12">Payment Status</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.eam_status_list}
                    value={this.state.selected_status}
                    onChange={this.handleSearchStatus}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 col-sm-12"
                style={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label className="col-sm-12">Employee ID</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.employeeIdList}
                    value={this.state.selected_employeeId}
                    onChange={this.handleSelectedEmpId}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-12"
                style={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label className="col-sm-12">Branch</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.branch}
                    value={this.state.selected_branch}
                    onChange={this.handleSelectedBranch}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>

              <div
                className="col-lg-3 col-md-6 col-sm-12"
                style={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label className="col-sm-12">Position</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.positionList}
                    value={this.state.selected_position}
                    onChange={this.handleSelectedPositon}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-12"
                style={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label className="col-sm-12">Region</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.regionList}
                    value={this.state.selected_region}
                    onChange={this.handleSelectedRegion}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div
                className="col-lg-3 col-md-6 col-sm-12 pl-0 pr-0"
                style={{
                  paddingLeft: "0",
                  paddingRight: "0",
                  marginBottom: "10px",
                }}
              >
                <div>
                  <label className="col-sm-12">Department</label>
                </div>
                <div className="col-md-10">
                  <Select
                    options={this.state.departmentList}
                    value={this.state.selected_department}
                    onChange={this.handleSelectedDepartment}
                    className="react-select-container checkValidate"
                    classNamePrefix="react-select"
                  />
                </div>
              </div>
              <div
                className="col-lg-2 col-md-6 col-sm-12"
                style={{
                  marginBottom: "10px",
                }}
              >
                <label htmlFor="">Start Date</label>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.start_date}
                  onChange={this.handleStartDate}
                  timeFormat={false}
                />
              </div>
              <div
                className="col-lg-2 col-md-6 col-sm-12"
                style={{
                  marginBottom: "10px",
                }}
              >
                <label htmlFor="">End Date</label>
                <DatePicker
                  dateFormat="DD/MM/YYYY"
                  value={this.state.end_date}
                  onChange={this.handleEndDate}
                  timeFormat={false}
                />
              </div>
              {/* Added end STHA  */}

              <div className="col-md-2">
                <button
                  className="btn btn-primary text-center"
                  style={{
                    marginLeft: 10,
                    marginBottom: "10px",
                    height: 30,
                    padding: "0px 5px 0px 5px",
                  }}
                  onClick={() => this.handleSearchData()}
                >
                  Search
                </button>
              </div>
            </div>
            <br />
            <div className="row">
              <div class="btn-group-g ">
                <button
                  type="button"
                  class="btn label-request g"
                  onClick={this.getRequest.bind(this)}
                >
                  Request
                </button>
                <button
                  type="button"
                  class=" btn label-check g"
                  onClick={this.getCheck.bind(this)}
                >
                  Check
                </button>
                <button
                  type="button"
                  class="btn label-verified g"
                  onClick={this.getVerified.bind(this)}
                >
                  Verify
                </button>
                {/* <button
                  type="button"
                  class="btn label-approve g"
                  onClick={this.getApprove.bind(this)}
                >
                  Approve
                </button> */}

                <button
                  type="button"
                  className="btn label-pending-for-payment g"
                  onClick={this.getPendingForPayment.bind(this)}
                >
                  Pending For Payment
                </button>

                <button
                  type="button"
                  class="btn label-reject g"
                  onClick={this.getReject.bind(this)}
                >
                  Reject
                </button>
              </div>
            </div>
            <table
              width="99%"
              className="table table-striped table-bordered table-hover table-responsive nowrap dt-responsive"
              id="dataTables-table"
            />
          </div>
        )}
      </div>
    );
  }
}

export default CycleTable;
